// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, RecaptchaVerifier } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCUJrI0cvEslbXdnS_r7WFgzhBLBXdkGZk",
  authDomain: "kaabharat-d20e3.firebaseapp.com",
  projectId: "kaabharat-d20e3",
  storageBucket: "kaabharat-d20e3.firebasestorage.app",
  messagingSenderId: "192644172435",
  appId: "1:192644172435:web:3866cde9c04b00d5c69b66",
  measurementId: "G-4RBSNF9X7G",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app); // Firestore database
const auth = getAuth(app); // Firebase Authentication

export { db, auth, RecaptchaVerifier };
